import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategory, fetchDepartment, fetchDesignation, getfinancialincrementtypes, fetchEmployeeIncrementApprovalCTC, saveEmployeeIncrementApprovalCTC, clearapproveError } from "store/actions";
import Select from 'react-select'
import { Row, Col, Card, CardBody, Container, Form, Modal, ModalHeader, ModalBody } from 'reactstrap'
import Breadcrumbs from "components/Common/Breadcrumb";
import TableContainer from "components/Common/TableContainer";
import * as Yup from "yup";
import { useFormik } from "formik";
import CustomSelect from "components/Common/custom-select";
import CustomMonthPicker from "common/CustomMonthPicker";
import dayjs from "dayjs";
import { FaCheck } from "react-icons/fa";
import { Input } from "reactstrap";
import Swal from "sweetalert2";


const IncrementApproval = () => {
  const [data, setData] = useState([]);
  const [financialYearRange, setFinancialYearRange] = useState({
    start: null,
    end: null,
  });
  const [tableData, setTableData] = useState([]);
  const [isSearched, setIsSearched] = useState(false);

  const [authDetails, setAuthDetails] = useState(null);

  const dispatch = useDispatch()

  const {
    categoryList,
    departmentList,
    finacial_types,
    employeeIncrementApprovalCTC,
    saveIncrementSuccess,
    successdata,
    success,
    loading,
    error,

  } = useSelector((state) => ({
    departmentList: state.EmployeeDetailsReducer?.departmentList ?? [],
    designationList: state.EmployeeDetailsReducer?.designationList ?? [],
    finacial_types: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.finacial_types,
    categoryList: state.EmployeeDetailsReducer?.categoryList ?? [],
    employeeIncrementApprovalCTC: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.employeeIncrementApprovalCTC ?? [],
    loading: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loading,
    successdata: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.successdata ?? [],
    error: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.error,
    success: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.success,
    saveIncrementSuccess: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.saveIncrementSuccess,
  }));

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategory(unitId));
    dispatch(fetchDepartment(unitId));
    dispatch(fetchDesignation(unitId));
    dispatch(getfinancialincrementtypes(unitId));
  }, [dispatch]);

  const handleSearch = async (e) => {
    e.preventDefault();
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.setTouched({ finyear: true, month: true });
      return;
    }

    if (!authDetails?.unit_id) return;
    const formData = new FormData();
    formData.append("unit_id", authDetails?.unit_id);
    formData.append("cat_id", selectedCategory?.value || 0);
    formData.append("dept_id", selectedDepartment?.value || 0);
    formData.append("fy_id", formik.values.finyear?.value || 0);
    formData.append("inc_month", formik.values.month ? dayjs(formik.values.month).startOf("month").format("YYYY-MM-DD") : "");
    dispatch(fetchEmployeeIncrementApprovalCTC(formData));
    setIsSearched(true);
  };

  const getFinancialYearRange = (finYear) => {
    if (!finYear) return { start: null, end: null };
    const [startYear, endYear] = finYear.split("-");
    return {
      start: dayjs(`${startYear}-04-01`),
      end: dayjs(`${endYear}-03-31`),
    };
  };

  useEffect(() => {
    if (employeeIncrementApprovalCTC?.length > 0) {
      const updated = employeeIncrementApprovalCTC.map((item) => ({
        ...item,
        selectedOption: null,
        actionRemarks: "",
      }));
      setTableData(updated);
    } else {
      setTableData([]);
    }
  }, [employeeIncrementApprovalCTC]);

  const handleOptionChange = (id, option) => {
    const updated = tableData.map((item) =>
      item.increment_id === id
        ? {
          ...item,
          selectedOption:
            item.selectedOption === option ? null : option,
        }
        : item
    );

    setTableData(updated);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      finyear: null,
      category: null,
      department: null,
      designation: null,
      emp_no: "",
      actionRemarks: "",
      month: null,
    },
    validationSchema: Yup.object({
      finyear: Yup.object().nullable().required("Financial year is required"),
      month: Yup.date().nullable().required("Increment month is required"),
    }),

    onSubmit: (values, { resetForm }) => {
      const selectedRows = tableData.filter(item => item.selectedOption) || [];
      if (selectedRows.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No Action Selected",
          text: "Please select at least one action.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      const rowsRequiringRemarks = selectedRows.filter(item => item.selectedOption === "Reject" || item.selectedOption === "Discussion");
      const missingRemarksRows = rowsRequiringRemarks.filter(item => !item.actionRemarks || item.actionRemarks.trim() === "");
      if (missingRemarksRows.length > 0) {
        const uniqueNames = [...new Set(missingRemarksRows.map(i => i.first_name))].join(", ");
        Swal.fire({
          icon: "warning",
          title: "Please provide remarks for Reject / Discussion ",
          html: uniqueNames,
          text: "Please select at least one before proceeding.",
        });
        return;
      }
      const incArray = selectedRows.map((item) => ({
        increment_id: item.increment_id,
        emp_id: item.emp_id,
        inc_type_id: item.increment_type,
        remarks: item.selectedOption === "Approve" ? "Approved" : item.actionRemarks || "",
        AppStatus: item.selectedOption === "Approve" ? "2" : item.selectedOption === "Reject" ? "3" : "4",
      }));

      const formData = new FormData();
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("created_by", authDetails?.user_id);
      formData.append("lst_employee_increment", JSON.stringify({ inc: incArray }));
      dispatch(saveEmployeeIncrementApprovalCTC(formData));
      resetForm();
    }
  });

  useEffect(() => {
    if (saveIncrementSuccess) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Increment approval updated successfully.",
        confirmButtonColor: "#28a745",
      });
      setTableData([]);
      setIsSearched(false);
      setSelectedCategory(null);
      setSelectedDepartment(null);
      formik.resetForm();
    }
  }, [saveIncrementSuccess]);

  const handleCancel = () => {
    formik.resetForm();
    setSelectedCategory(null);
    setSelectedDepartment(null);
    setFinancialYearRange({ start: null, end: null, });
    setTableData([]);
    setIsSearched(false);
  };

  const handleRemarksChange = (id, value) => {
    setTableData((prev) => prev.map((item) => item.increment_id === id ? { ...item, actionRemarks: value } : item));
  };

  const columns = [
    { Header: "S.No", Cell: ({ row }) => employeeIncrementApprovalCTC.length - row.index, className: "serial-no", applyHeaderClass: true, },
    { Header: "Code", accessor: "emp_no" },
    { Header: "Name", accessor: "first_name" },
    { Header: "Date", accessor: "increment_date" },
    { Header: "Revision", accessor: "revision" },
    { Header: "Old CTC", accessor: "old_ctc" },
    { Header: "Inc Amount", accessor: "increment_amount" },
    { Header: "New CTC", accessor: "new_ctc" },
    { Header: "Remarks", accessor: "remarks" },
    { Header: "Designation", accessor: "designation" },
    {
      Header: "Action Remarks",
      Cell: ({ row }) => {
        const [value, setValue] = React.useState(
          row.original.actionRemarks || ""
        );

        React.useEffect(() => {
          setValue(row.original.actionRemarks || "");
        }, [row.original.actionRemarks]);

        const handleBlur = () => {
          handleRemarksChange(row.original.increment_id, value);
        };

        return (
          <Input type="text" bsSize="sm" placeholder="Enter remarks" value={value}
            disabled={row.original.selectedOption === "Approve" || !row.original.selectedOption}
            onChange={(e) => setValue(e.target.value)}
            onBlur={handleBlur}
          />
        );
      },
    },
    {
      id: "approve",
      Header: "Approve",
      Cell: ({ row }) => (
        <div className="d-flex justify-content-center align-items-center" style={{ cursor: "pointer" }}
          onClick={() => handleOptionChange(row.original.increment_id, "Approve")}
        >
          {row.original.selectedOption === "Approve" ? (<FaCheck color="green" size={18} />) : (<Input type="checkbox" checked={false} readOnly />)}
        </div>
      ),
    },
    {
      id: "reject",
      Header: "Reject",
      Cell: ({ row }) => (
        <div className="d-flex justify-content-center align-items-center" style={{ cursor: "pointer" }}
          onClick={() => handleOptionChange(row.original.increment_id, "Reject")}
        >
          {row.original.selectedOption === "Reject" ? (<FaCheck color="red" size={18} />) : (<Input type="checkbox" checked={false} readOnly />)}
        </div>
      ),
    },
    {
      id: "discussion",
      Header: "Discussion",
      Cell: ({ row }) => (
        <div className="d-flex justify-content-center align-items-center" style={{ cursor: "pointer" }}
          onClick={() => handleOptionChange(row.original.increment_id, "Discussion")}
        >
          {row.original.selectedOption === "Discussion" ? (<FaCheck color="orange" size={18} />) : (<Input type="checkbox" checked={false} readOnly />)}
        </div>
      ),
    },
  ];
  const hasErrorData = Array.isArray(successdata?.data) && successdata.data.length > 0;

  const incrementapprovals = [
    {
      Header: "CODE",
      accessor: "emp_no",
    },
    {
      Header: "NAME",
      accessor: "emp_name",
    },
    {
      Header: "INCREMENT_AMOUNT",
      accessor: "inc_amount",
    },
    {
      Header: "APPROVED_STATUS",
      accessor: "approved_status",
    },
    {
      Header: "REMARKS",
      accessor: "approved_remarks",
    }
  ];

  const res_columns = incrementapprovals;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Payroll / Increment" breadcrumbItem="Increment Approval" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="row mb-3">
                      <div className="col-md-3">
                        <label>Category</label>
                        <Select
                          id="department"
                          name="department"
                          options={categoryList.map((dept) => ({ value: dept.empCatgryid, label: dept.empCategory, }))}
                          value={selectedCategory}
                          onChange={(selected) => setSelectedCategory(selected)}
                          isClearable
                          className="hrms-select"
                          classNamePrefix="hrms-select"
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Department</label>
                        <Select
                          id="department"
                          name="department"
                          options={departmentList.map((dept) => ({ value: dept.departmentId, label: dept.departmentname, }))}
                          value={selectedDepartment}
                          onChange={(selected) => setSelectedDepartment(selected)}
                          isClearable
                          className="hrms-select"
                          classNamePrefix="hrms-select"
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Financial Year <span className="text-danger">*</span></label>
                        <CustomSelect
                          id="finyear"
                          name="finyear"
                          isMulti={false}
                          options={finacial_types?.finacial_year?.map((fy) => ({ value: fy.fy_id, label: fy.fin_year, fin_year: fy.fin_year })) || []}
                          value={formik.values.finyear || null}
                          onChange={(selectedOption) => {
                            formik.setFieldValue("finyear", selectedOption);
                            const range = getFinancialYearRange(selectedOption?.fin_year);
                            setFinancialYearRange(range);
                            formik.setFieldValue("month", null);
                          }}
                          onBlur={() => formik.setFieldTouched("finyear", true)}
                        />
                        {formik.touched.finyear && formik.errors.finyear && (
                          <div className="text-danger small">{formik.errors.finyear}</div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Inc Month <span className="text-danger">*</span></label>
                        <CustomMonthPicker
                          name="month"
                          value={formik.values.month}
                          onChange={(date) => { formik.setFieldValue("month", date); }}
                          onBlur={() => formik.setFieldTouched("month", true)}
                          minDate={financialYearRange.start}
                          maxDate={financialYearRange.end}
                          disableFuture={true}
                          className="form-control form-control-sm"
                          classNamePrefix="react-select"
                          isClearable={true}
                        />
                        {formik.touched.month && formik.errors.month && (
                          <div className="text-danger small">{formik.errors.month}</div>
                        )}
                      </div>
                    </div>

                    <Col className="text-end">
                      <button type="button" className="btn button-search me-2" onClick={handleSearch}><i className="fas fa-search me-1" /> Search</button>
                      <button type="submit" className="btn btn-success me-2" disabled={!isSearched}><i className="fas fa-save me-1" />Submit</button>
                      <button type="button" className="btn button-cancel" onClick={handleCancel}><i className="fas fa-sync me-1" /> Cancel</button>
                    </Col>
                  </Form>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  {isSearched && (
                    <TableContainer columns={columns} data={tableData || []} isGlobalFilter={true} customPageSize={10} className="custom-header-css" />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {hasErrorData && (
            <Modal
              isOpen={hasErrorData}
              size="lg"
              toggle={() => dispatch(clearapproveError())}
            >
              <ModalHeader toggle={() => dispatch(clearapproveError())} className="bg-danger text-white absent-modal-header">
                {successdata?.message}
              </ModalHeader>

              <ModalBody>
                <TableContainer
                  columns={res_columns}
                  data={successdata?.data || []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  tableSorter={true}
                />
              </ModalBody>
            </Modal>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IncrementApproval;
